export default __webpack_public_path__ + "static/media/CQ2.ee82121e.png";